<template>
  <header class="l-header">
    <div class="l-header__inner">
      <div class="l-header__logo">
        <a @click="redirectToMyPage()"
          ><img src="../../assets/img/header/logo.png" alt="MEN'S SVENSON"
        /></a>
      </div>
      <div v-if="isShowLoginHeader" class="l-header__ui">
        <div class="head-ui__btn">
          <div class="c-btn c-btn--head-login">
            <a href="#" @click="redirectLoginPage()">ログイン</a>
          </div>
        </div>
      </div>
      <div v-if="isShowLogoutHeader" class="l-header__ui">
        <div class="head-ui__btn">
          <v-btn outlined class="white--text mx-1 icon-btn" to="/mypage/profile">
            <img :src="editIcon" alt="" class="icon" />
            <p class="mb-0">{{ profileText }}</p>
          </v-btn>

          <v-btn outlined class="white--text mx-1 icon-btn" @click="Logout">
            <img :src="logoutIcon" alt="" class="icon" />
            <p class="mb-0">{{ logoutText }}</p>
          </v-btn>
        </div>
      </div>
      <div v-if="isShowUserHeader" class="l-header__ui">
        <div class="head-ui__btn">
          <div class="c-btn c-btn--head-mypage">
            <a href="#" @click="redirectToMyPage()">{{ myPageText }}</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { logout } from '../../actions/requestLogin'
import logoutIcon from '@/assets/img/header/logout.svg'
import editIcon from '@/assets/img/header/edit.svg'

export default {
  name: 'Header',
  data() {
    return {
      logoutIcon,
      editIcon,
      profileText: '登録情報編集',
      logoutText: 'ログアウト',
      myPageText: 'マイページ',
    }
  },
  props: {
    isShowLoginHeader: {
      type: Boolean,
      default: false,
    },
    isShowLogoutHeader: {
      type: Boolean,
      default: false,
    },
    isShowUserHeader: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    Logout() {
      this.$authInfo.setToken(sessionStorage.getItem('token'))
      logout()
        .then((res) => {
          const {
            data: { success },
          } = res
          if (success && success === 1) {
            this.$authInfo.setToken('')
            this.$authInfo.setUser({})
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('userInfo')
            sessionStorage.removeItem('userLinked')
            sessionStorage.removeItem('studioInfo')
            sessionStorage.removeItem('userId')
            sessionStorage.removeItem('user')
            sessionStorage.removeItem('from_email_link')
            sessionStorage.removeItem('booking')
            sessionStorage.removeItem('linked')
            this.redirectLoginPage()
          }
        })
        .catch((err) => {
          return err
        })
    },
    redirectLoginPage() {
      this.$router.push({
        name: 'login',
      })
      location.reload()
    },
    redirectToMyPage() {
      const currentUrl = window.location.pathname
      if (currentUrl === '/account') {
        this.Logout()
      } else {
        this.$router.push({
          name: 'mypage',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #fff;
}

.icon-btn {
  height: 40px;
  width: 140px;
  font-size: 14px;
}

.icon {
  width: 18px;
  height: 18px;
}

@media (max-width: 600px) {
  .icon-btn {
    height: 40px !important;
    width: fit-content;
    padding: 8px 10px 8px 10px !important;
    font-size: 12px;
    letter-spacing: initial;
  }

  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }

  @media (max-width: 600px) {
    .icon-btn {
      height: 32px !important;
      padding: 8px 6px 8px 6px !important;
      font-size: 9px;
    }

    .icon {
      width: 12px;
      height: 12px;
      margin-right: 2px;
    }
  }
}
</style>
